import React from 'react';
import { withRouter } from 'react-router';
import { Helmet } from 'react-helmet-async';
import RegisterSection, {
  RegistrationProps,
} from '../components/RegisterSection';
import Title from '../components/Title';
import { useFlow } from '../utilities/useFlow';

interface RegistrationComponentProps extends RegistrationProps {}

function RegistrationComponent(props: RegistrationComponentProps): JSX.Element {
  const flow = useFlow();

  return (
    <>
      <Helmet>
        <title>{`Register | ${flow}`}</title>
        <meta name="description" content={`Create your ${flow} account to book student storage, box shipping, and removals services across the UK.`} />
      </Helmet>
      <Title>Registration</Title>
      <RegisterSection {...props} />
    </>
  );
}

export default withRouter(RegistrationComponent);
